module.exports = __webpack_public_path__ + "static/media/14UNEP6.d77ee9c2.jpg";